export default __webpack_public_path__ + "static/media/962.c5eeffa4.gif";